import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconGol, CreditRequestCard, CreditRequestModalForm, IconRestore } from '../../components';

const CreditRequest = () => {
  const { t } = useTranslation('creditRequest');
  const [isOpenModalForm, setIsOpenModalForm] = useState(false);

  const toggleFormModal = () => setIsOpenModalForm(!isOpenModalForm);

  const handleOpenModalForm = () => {
    setIsOpenModalForm(!isOpenModalForm);
  };
  return (
    <>
      <div className="select-company-wrapper">
        <div className="select-company-title">
          <h3> {t('select_company_title')}</h3>
        </div>
        <div className="credit-request-card-container">
          <CreditRequestCard icon={<IconGol />} onClick={handleOpenModalForm} companyName={t('company_name_gol')} />
          <CreditRequestModalForm
            icon={<IconRestore />}
            isOpenModalForm={isOpenModalForm}
            toggleFormModal={toggleFormModal}
          />
        </div>
      </div>
    </>
  );
};

export default CreditRequest;
